"use strict";

/**
 * @module Services.GatewayControl
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvokeOperationResponse = void 0;
/**
 * Gateway response following invocation of an operation.
 */
var InvokeOperationResponse = /** @class */function () {
  /**
   * Create a new InvokeOperationResponse instance
   * @param type response type
   * @param output the output of the operation, if there was any.
   */
  function InvokeOperationResponse(type, output) {
    this.type = type;
    this.output = output;
  }
  return InvokeOperationResponse;
}();
exports.InvokeOperationResponse = InvokeOperationResponse;